import React, { useState, useEffect } from "react";
import axios from "axios";
import "../index.css";

const MyBooks = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (!token || !userId) {
          setError("User not authenticated");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND}/api/rides/getuserbookings?userId=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setBookings(response.data);
      } catch (err) {
        console.error("Error fetching bookings:", err);
        setError("Failed to fetch your bookings.");
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;

  return (
    <div className="mybooks-container">
      <h2 className="mybooks-heading">My Bookings</h2>
      {bookings.length === 0 ? (
        <p className="text-center">No bookings found.</p>
      ) : (
        <div className="row g-4">
          {bookings.map((booking) => (
            <div className="col-md-6 col-lg-4" key={booking._id}>
              <div className="card mybooks-card shadow-sm h-100">
                <div className="card-body">
                  <h5 className="card-title mb-2 text-primary">{booking.serviceType}</h5>
                  <div className="mb-2"><strong>Pickup:</strong> {booking.pickupLocation}</div>
                  <div className="mb-2"><strong>Dropoff:</strong> {booking.dropoffLocation}</div>
                  <div className="mb-2"><strong>Date:</strong> {booking.pickupDate} <strong>Time:</strong> {booking.pickupTime}</div>
                  <div className="mb-2"><strong>Passengers:</strong> {booking.passengers} <strong>Luggage:</strong> {booking.luggage}</div>
                  <div className="mb-2"><strong>Child Seats:</strong> {Array.isArray(booking.childSeats) && booking.childSeats.length > 0 ? booking.childSeats.map((seat, i) => seat.type || seat).join(", ") : "-"}</div>
                  <div className="mb-2"><strong>Vehicle:</strong> {booking.vehicle}</div>
                  <div className="mb-2"><strong>Name:</strong> {booking.firstName} {booking.lastName}</div>
                  <div className="mb-2"><strong>Phone:</strong> {booking.phoneNumber}</div>
                  <div className="mb-2"><strong>Email:</strong> {booking.email}</div>
                </div>
                <div className="card-footer bg-transparent border-0 text-end">
                  <span className="badge bg-success fs-5">${booking.rent}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyBooks;
